<template>
    <v-row>
        <v-col>
            <v-card>
                <v-card-text>
                    <v-row>
                        <v-col cols="12">
                            <organization-user-list ref="orgUser"></organization-user-list>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import OrganizationUserList from '@/components/Organization/OrganizationUserList.vue';
import {mapGetters, mapActions} from 'vuex';
export default {
    name: 'OrganizationsPage',
    components:{
        OrganizationUserList
    },
    data(){
        return {
            snackbar: {
                isShow: false,
                color: "success",
                message: ''
            }
        }
    },
    methods: {
        ...mapActions('notifications', ['SHOW_MESSAGE']),
        showSnackbar(message, color){
            this.SHOW_MESSAGE({message, props:{color}});
        }
    },
    computed: {
        ...mapGetters( 'user', ['USER_ID']),
        ...mapGetters( 'workspace', ['ID_WORK_SPACE']),
    }
}
</script>